import React from 'react'
import styled from 'styled-components'

const Comp = styled.div`
  ${props => props.disabled 
    ? 'background: #173DB0; color: #fff; cursor: not-allowed;' 
    : 'background: #173DB0; color: #fff; cursor: pointer; &:hover { background: red; }' 
  }
  padding: 21px;
  display: inline-block;
  transition: all .3s ease;  
`

const Button = ({ onClick, disabled, children, hidden, style }) => (
  <Comp
    className="button"
    onClick={onClick}
    style={{
      ...(hidden && {display: 'none'}),
      ...(style && style),
    }}
    disabled={disabled}
  >
    {children}
  </Comp>
)

export default Button



// WEBPACK FOOTER //
// ./src/basic/button.js